// src/constants/styles.ts

export const COLORS = {
  accentDarkGreen: '#1C4040',
  accentLime: '#C2FC85',
  accentOffWhite: '#F9F7F5',
  accentBlackTransparent: '#000000B0',
  white: '#FFFFFF',
  pureBlack: '#000000',
  lightBlack: '#0000001A',
  mediumBlack: '#00000040',
  stickyHeaderBg: '#FFFFFFA1',
  lightGreenTransparent: '#7EF50061',
  whiteSemiTransparent: '#FFFFFFB3',
  lightGrayTransparent: '#F9F9F966',
  darkGreenTransparent: '#4C7E24CC',
  greyBG: '#F9F8F6',
};


export const TYPOGRAPHY = {
  font_basic: {
    fontFamily: "'Big Shoulders Text', sans-serif",
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'uppercase',
    textDecoration: 'none',
    lineHeight: '1.2rem',
    letterSpacing: '1px',
  },
  primaryFont: {
    family: 'Inter',
    size: '16px',
    weight: 'normal',
    lineHeight: '1.5em',
  },
  heading1: {
    family: 'Big Shoulders Text',
    size: '48px',
    weight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.1em',
  },
  heading2: {
    family: 'Big Shoulders Text',
    size: '32px',
    weight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.2em',
  },
  heading3: {
    family: 'Big Shoulders Text',
    size: '22px',
    weight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.3em',
    letterSpacing: '1px',
  },
  heading4: {
    family: 'Big Shoulders Text',
    size: '20px',
    weight: 500,
    textTransform: 'uppercase',
    lineHeight: '1.4em',
  },
  heading5: {
    family: 'Inter',
    size: '18px',
    weight: 400,
    lineHeight: '1.4em',
  },
  heading6: {
    family: 'Big Shoulders Text',
    size: '14px',
    weight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.1em',
    letterSpacing: '1px',
  },
  heroLarge: {
    family: 'Big Shoulders Text',
    size: '64px',
    weight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.1em',
  },
  bodyLarge: {
    size: '18px',
    lineHeight: '1.5em',
    letterSpacing: '-0.3px',
  },
  smallText: {
    family: 'Inter',
    size: '14px',
    weight: 400,
    lineHeight: '1.4em',
  },
  extraSmallText: {
    size: '13px',
    lineHeight: '1.4em',
  },
  bigButtonText: {
    size: '20px',
    weight: 600,
    lineHeight: '1.2em',
  },
  labelText: {
    family: 'Big Shoulders Text',
    size: '16px',
    weight: 600,
    textTransform: 'uppercase',
    lineHeight: '1.2em',
  },
  hugeHeroText: {
    family: 'Big Shoulders Text',
    size: 'clamp(2rem, 11vw, 180px)',
    weight: 700,
    lineHeight: '1em',
  },
  handwrittenText: {
    family: 'Indie Flower',
    size: '22px',
    lineHeight: '1.2em',
  },
  secondaryButtonText: {
    size: '18px',
    weight: 500,
    lineHeight: '1.6em',
  },
  badgeText: {
    family: 'Big Shoulders Text',
    size: '11px',
    weight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    lineHeight: '1.2em',
  },
};
